import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';

const emptyForm = {
  title: '',
  value: '',
  note: '',
};

const DocumentFormModal = ({
  isOpen,
  mode,
  initialValues,
  onClose,
  onSave,
  saving,
  error,
}) => {
  const [form, setForm] = useState(emptyForm);
  const noteRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setForm({
        title: initialValues?.title || '',
        value: initialValues?.value || '',
        note: initialValues?.note || '',
      });
    }
  }, [isOpen, initialValues]);

  useEffect(() => {
    const textarea = noteRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [form.note, isOpen]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave(form);
  };

  const title = mode === 'edit' ? 'Edit document' : 'Add document';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="border border-gray-300 bg-white rounded-lg px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            form="document-form"
            disabled={saving}
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-4 py-2 text-sm disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
        </>
      }
    >
      <form id="document-form" onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="document-title" className="block text-sm text-gray-700 mb-1">
            Document name
          </label>
          <input
            id="document-title"
            type="text"
            value={form.title}
            onChange={handleChange('title')}
            required
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
          />
        </div>

        <div>
          <label htmlFor="document-value" className="block text-sm text-gray-700 mb-1">
            Value
          </label>
          <input
            id="document-value"
            type="text"
            value={form.value}
            onChange={handleChange('value')}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
          />
        </div>

        <div>
          <label htmlFor="document-note" className="block text-sm text-gray-700 mb-1">
            Note
          </label>
          <textarea
            id="document-note"
            ref={noteRef}
            value={form.note}
            onChange={handleChange('note')}
            rows={1}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm resize-none overflow-hidden outline-none focus:border-gray-400"
          />
        </div>

        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
      </form>
    </Modal>
  );
};

export default DocumentFormModal;
